import { httpClient } from "@utils";
import { getApiRequestContext } from "@utils/api-config";
import { getMvcRequestHeaders } from "@utils/api-config/getMvcRequestHeaders";
import { ApiRequestContextData, ContextOptions } from "@utils/api-config/types";

export default class AgencyUserAccountRelationApiService {
	private static get baseUrl(): string {
		return `${WEBPACK_BASE_ADDRESS}platform/agency-user-account-relation-matches`;
	}

	static getRequestHeaders = (
		context: ApiRequestContextData | null
	): HeadersInit => {
		const appHeaders = getMvcRequestHeaders(context);
		appHeaders["Content-Type" as keyof HeadersInit] = "application/json";
		return appHeaders;
	};

	static async findMatchingData(options?: ContextOptions): Promise<string[]> {
		const context = getApiRequestContext(options);
		const headers = this.getRequestHeaders(context);

		return httpClient.get(this.baseUrl, headers);
	}

	static async denyUserMatching(options?: ContextOptions): Promise<void> {
		const context = getApiRequestContext(options);
		const headers = this.getRequestHeaders(context);
		const url = `${this.baseUrl}/deny`;

		return httpClient.post(url, null, headers);
	}
}
